import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Pricing = () => {
  const navigate = useNavigate();

  const plans = [
    {
      name: "Freedom",
      monthlyPrice: "$25",
      annualPrice: "$275",
      monthlyEquivalent: "$22.92",
      description: "Nourish, move, track, and thrive with confidence",
      features: [
        "Full recipe library with filters (allergy-friendly, diet type)",
        "Complete workout library (glute, corporate, prenatal, etc)",
        "Cycle tracking with ovulation predictions & fertility insights",
        "Goal setting & progress tracking tools",
        "Journal reflections for mindfulness & self-discovery",
        "Exclusive wellness guides (eczema, anti-inflammatory)",
        "Premium community access (Q&As, recipe swaps)",
        "Early access to new products + free seasonal ebooks"
      ],
      buttonText: "Join Freedom",
      buttonStyle: "text-white hover:opacity-90",
      buttonColor: "#d9a79c",
      popular: false
    }
  ];

  return (
    <section id="pricing" className="relative py-16" style={{ backgroundColor: '#F5EBDD' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-playfair font-light text-charcoal-900 mb-6">
            Join the Alera Community
          </h2>
          <div
            className="w-28 h-1 mx-auto rounded-full"
            style={{ background: 'linear-gradient(90deg, #d9a79c 0%, rgba(201,163,130,0.8) 50%, #d9a79c 100%)' }}
          ></div>
        </motion.div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-1 gap-8 max-w-3xl mx-auto items-stretch">
          {plans.map((plan, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -8, scale: 1.02 }}
              className={`relative bg-gradient-to-br from-rose-50/40 to-beige-50/40 rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-all duration-500 flex flex-col h-full`}
              style={{ borderWidth: '2px', borderColor: '#f0e0dc' }}
            >
              {/* Popular Badge */}
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span style={{ backgroundColor: '#d9a79c' }} className="text-white px-6 py-2 rounded-full text-sm font-medium">
                    Most Popular
                  </span>
                </div>
              )}

              {/* Plan Header */}
              <div className="text-center mb-8">
                <h3 className="text-2xl font-playfair font-semibold text-charcoal-900 mb-2">
                  {plan.name}
                </h3>
                <div className="mb-4">
                  <p className="text-5xl font-bold text-charcoal-900 mb-2">{plan.monthlyPrice}<span className="text-2xl text-charcoal-600">/month</span></p>
                  <p className="text-sm text-charcoal-500 font-nunito">Annual plans available</p>
                </div>
                <p className="text-charcoal-600 leading-relaxed font-nunito">
                  {plan.description}
                </p>
              </div>

              {/* Features List */}
              <div className="flex-1 mb-8">
                <ul className="space-y-4">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <svg style={{ color: '#d9a79c' }} className="w-5 h-5 mt-0.5 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-charcoal-700 font-nunito">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA Button */}
              <div className="mt-auto">
                <button 
                  onClick={() => navigate('/signup')}
                  style={{ backgroundColor: plan.buttonColor || '#d9a79c' }}
                  className={`w-full py-4 px-6 rounded-2xl font-semibold transition-all duration-300 transform hover:scale-105 ${plan.buttonStyle}`}>
                  {plan.buttonText}
                </button>
                <p className="text-sm text-charcoal-500 text-center mt-3 font-nunito">
                  Cancel anytime • Flexible and stress-free
                </p>
              </div>
            </motion.div>
          ))}
        </div>

      </div>

      {/* Starter Packs CTA now routes to Services; modal removed */}
    </section>
  );
};

export default Pricing;
